// extracted by mini-css-extract-plugin
export default {"DeliverOrdersPage":"DeliverOrdersPage_DeliverOrdersPage__EfpgQ"};